import React from 'react';

// import { Container } from './styles';

export default function Dashboard() {
  return (
    <h1></h1>
  );
}
